import { render, staticRenderFns } from "./EmployeeLayout.vue?vue&type=template&id=2b487cc0"
import script from "./EmployeeLayout.vue?vue&type=script&lang=js"
export * from "./EmployeeLayout.vue?vue&type=script&lang=js"
import style0 from "./EmployeeLayout.vue?vue&type=style&index=0&id=2b487cc0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports